"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_STRINGS = void 0;
exports.AI_STRINGS = {
    executionCancelled: 'Execution cancelled',
    executionFailed: 'Execution failed',
};
